import React from 'react';

import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

const PreventDrop: React.FC = () => (
  <div className={styles.dragHotspot}>
    <span className={styles.hint}>{intlGet('Artboard.NonCompatibleZone', 'Hint')}</span>
  </div>
);

export default PreventDrop;
